import {Injectable} from '@angular/core';
import {PaginatorService} from "@shared/api/services/paginator.service";
import {Appointment} from "@shared/api/models/query/appointment.model";
import {GetService} from "@shared/api/services/get.service";
import {RecordNoteType} from "@shared/api/models/query/patient-record-appointment-note.model";

@Injectable({
    providedIn: 'root'
})
export class RecordNoteTypeService extends PaginatorService<RecordNoteType> {

    protected override get domainEntity() {
        return 'lists/record-note-types';
    };
}
